import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { MENTION_PATTERN, escapeHtml, mentionChip } from './mention-chip';

/**
 * Renders a user message: everything stays literal text except pinned references, which
 * become chips.
 *
 * Deliberately not the markdown pipe. A user's own words should not be reinterpreted —
 * someone pasting `**not bold**` or a stray `#` expects to see what they typed. The only
 * transformation is the one the composer itself introduced.
 */
@Pipe({ name: 'mentions', standalone: true })
export class MentionsPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    if (!value) return '';

    // Escape first, then substitute: the pattern's delimiters are brackets and
    // parentheses, which escaping leaves alone, so it still matches afterwards — and
    // nothing the user typed can reach the DOM as markup.
    const html = escapeHtml(value).replace(MENTION_PATTERN, (_match, label: string, kind: string, code: string) =>
      mentionChip(`@${label}`, kind, code)
    );

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
